
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings as SettingsIcon, Shield, Bell, Volume2, HardDrive } from 'lucide-react';
import PasswordManagement from '@/components/settings/PasswordManagement';
import { BackupManagementEnhanced } from '@/components/settings/BackupManagementEnhanced';
import NotificationSettings from '@/components/notifications/NotificationSettings';
import SoundSettings from '@/components/settings/SoundSettings';
import { StorageManagement } from '@/components/settings/StorageManagement';

const Settings = () => {
  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2 mb-2">
          <SettingsIcon className="h-8 w-8 text-primary" />
          Settings
        </h1>
        <p className="text-muted-foreground">
          Manage your application preferences and configurations (localStorage only - 5000+ capacity)
        </p>
      </div>

      <Tabs defaultValue="security" className="space-y-6">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="security" className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            Security
          </TabsTrigger>
          <TabsTrigger value="backup" className="flex items-center gap-2">
            <HardDrive className="h-4 w-4" />
            Backup
          </TabsTrigger>
          <TabsTrigger value="notifications" className="flex items-center gap-2">
            <Bell className="h-4 w-4" />
            Notifications
          </TabsTrigger>
          <TabsTrigger value="sound" className="flex items-center gap-2">
            <Volume2 className="h-4 w-4" />
            Sound
          </TabsTrigger>
          <TabsTrigger value="storage" className="flex items-center gap-2">
            <HardDrive className="h-4 w-4" />
            Storage
          </TabsTrigger>
        </TabsList>

        <TabsContent value="security" className="space-y-6">
          <PasswordManagement />
        </TabsContent>

        <TabsContent value="backup" className="space-y-6">
          <BackupManagementEnhanced />
        </TabsContent>

        <TabsContent value="notifications" className="space-y-6">
          <NotificationSettings />
        </TabsContent>

        <TabsContent value="sound" className="space-y-6">
          <SoundSettings />
        </TabsContent>

        <TabsContent value="storage" className="space-y-6">
          <StorageManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Settings;
